var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagesStampsGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 135,
    viewBox: "0 0 140 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.399 49.78L128.589 127.63C128.477 128.919 127.858 130.11 126.868 130.943C125.878 131.776 124.597 132.181 123.309 132.07L53.9885 126.04C52.6989 125.926 51.5073 125.305 50.675 124.313C49.8427 123.321 49.4376 122.04 49.5485 120.75L57.4285 30.62C57.5455 29.3315 58.1673 28.1414 59.1583 27.3096C60.1494 26.4778 61.4292 26.0718 62.7185 26.18L120.519 31.18L135.399 49.78Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7284 17.08L67.0084 18.72L65.3784 0L85.7284 17.08Z",
    fill: "#B4C5D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7284 17.08L67.0084 18.72L65.3784 0L85.7284 17.08Z",
    stroke: "#B4C5D0",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6285 41.98L23.5685 42.25L22.9885 44.51L21.9885 44.6L24.1485 36.67L25.0885 36.59L28.5985 44.04L27.5985 44.13L26.6285 41.98ZM23.7785 41.41L26.2685 41.19L24.7385 37.79L23.7785 41.41Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0684 80.67L25.3984 73.04L28.3984 72.77C28.6688 72.7172 28.9472 72.7208 29.2161 72.7806C29.485 72.8404 29.7387 72.9551 29.9612 73.1175C30.1837 73.2799 30.3703 73.4866 30.5092 73.7245C30.6481 73.9624 30.7364 74.2264 30.7684 74.5C30.7908 74.8782 30.6884 75.2532 30.4771 75.5675C30.2657 75.8818 29.957 76.1181 29.5984 76.24C29.8417 76.232 30.0842 76.2724 30.3118 76.3588C30.5394 76.4452 30.7476 76.5759 30.9243 76.7433C31.101 76.9107 31.2428 77.1115 31.3413 77.3341C31.4399 77.5567 31.4933 77.7967 31.4984 78.04C31.6184 79.39 30.7184 80.28 29.0884 80.42L26.0684 80.67ZM26.6484 76.21L28.1784 76.04C29.3184 75.94 29.8884 75.43 29.8184 74.6C29.7484 73.77 29.1984 73.47 28.2684 73.6L26.4284 73.76L26.6484 76.21ZM28.8484 79.57C30.0084 79.47 30.5684 78.95 30.4984 78.06C30.4284 77.17 29.7484 76.77 28.4984 76.88L26.7184 77.04L26.9584 79.74L28.8484 79.57Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2885 49.46C30.1872 49.46 34.1585 45.4887 34.1585 40.59C34.1585 35.6912 30.1872 31.72 25.2885 31.72C20.3897 31.72 16.4185 35.6912 16.4185 40.59C16.4185 45.4887 20.3897 49.46 25.2885 49.46Z",
    stroke: "#B4C5D0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4486 85.5599C33.3474 85.5599 37.3186 81.5887 37.3186 76.6899C37.3186 71.7912 33.3474 67.8199 28.4486 67.8199C23.5498 67.8199 19.5786 71.7912 19.5786 76.6899C19.5786 81.5887 23.5498 85.5599 28.4486 85.5599Z",
    stroke: "#B4C5D0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1284 17.29L83.6184 22.85",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0985 59.0399C71.3889 59.0543 71.6733 59.1271 71.9349 59.254C72.1964 59.3809 72.4296 59.5593 72.6206 59.7785C72.8115 59.9977 72.9562 60.2532 73.0461 60.5297C73.136 60.8061 73.1691 61.0979 73.1435 61.3875C73.1179 61.677 73.0341 61.9585 72.8972 62.2149C72.7602 62.4713 72.5729 62.6974 72.3465 62.8797C72.1201 63.062 71.8592 63.1968 71.5794 63.2759C71.2997 63.3549 71.0069 63.3767 70.7185 63.34L69.0285 63.2L68.8185 65.5799L67.9885 65.5099L68.5785 58.8199L71.0985 59.0399ZM69.0985 62.4599L70.5685 62.5799C70.753 62.5964 70.939 62.5763 71.1157 62.5208C71.2925 62.4654 71.4566 62.3757 71.5986 62.2568C71.7407 62.138 71.858 61.9923 71.9437 61.8281C72.0295 61.6639 72.0821 61.4845 72.0985 61.2999C72.1149 61.1154 72.0949 60.9295 72.0394 60.7528C71.984 60.576 71.8943 60.4119 71.7754 60.2699C71.6565 60.1278 71.5109 60.0105 71.3467 59.9247C71.1825 59.839 71.003 59.7864 70.8185 59.77L69.3485 59.6399L69.0985 62.4599Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3586 66.42C75.4886 66.26 74.3586 64.79 74.5986 62.66C74.8386 60.53 76.0886 59.35 77.9586 59.51C78.614 59.5307 79.2397 59.7884 79.7196 60.2352C80.1996 60.6821 80.5012 61.2878 80.5686 61.94L79.6886 61.87C79.6158 61.439 79.3974 61.0461 79.0698 60.7567C78.7422 60.4673 78.3253 60.2991 77.8886 60.28C76.4986 60.16 75.5986 61.04 75.4986 62.73C75.3986 64.42 76.0986 65.53 77.4986 65.65C77.7553 65.694 78.0184 65.6836 78.2708 65.6194C78.5232 65.5553 78.7594 65.4388 78.9639 65.2776C79.1685 65.1164 79.3369 64.9141 79.4583 64.6837C79.5797 64.4532 79.6514 64.1999 79.6686 63.94V63.82L77.7886 63.65L77.8486 62.92L80.5686 63.16V63.79C80.5785 64.1901 80.497 64.5872 80.3302 64.951C80.1634 65.3148 79.9158 65.6357 79.6062 65.8893C79.2966 66.143 78.9333 66.3226 78.5438 66.4146C78.1543 66.5065 77.7489 66.5084 77.3586 66.42Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9586 100.41C68.9586 101.22 69.6986 101.81 70.7586 101.91C71.8186 102.01 72.5386 101.53 72.5986 100.8C72.6586 100.07 72.2586 99.74 71.2786 99.4L70.3486 99.07C69.0086 98.6 68.4486 97.94 68.5386 96.93C68.6486 95.7 69.8086 94.93 71.3486 95.06C71.6622 95.052 71.9743 95.1069 72.2663 95.2214C72.5584 95.3359 72.8246 95.5077 73.0492 95.7268C73.2738 95.9458 73.4523 96.2076 73.5741 96.4967C73.696 96.7858 73.7587 97.0963 73.7586 97.41L72.8286 97.33C72.8286 96.52 72.2186 95.98 71.2486 95.89C70.2786 95.8 69.5686 96.25 69.5086 96.98C69.4586 97.54 69.8386 97.91 70.8286 98.26L71.5886 98.53C73.0886 99.05 73.6686 99.7 73.5886 100.77C73.4686 102.13 72.3286 102.88 70.5886 102.77C68.8486 102.66 67.9886 101.69 68.0186 100.36L68.9586 100.41Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3886 71.5501C79.2873 71.5501 83.2586 67.5788 83.2586 62.6801C83.2586 57.7813 79.2873 53.8101 74.3886 53.8101C69.4898 53.8101 65.5186 57.7813 65.5186 62.6801C65.5186 67.5788 69.4898 71.5501 74.3886 71.5501Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2286 107.65C76.1274 107.65 80.0986 103.679 80.0986 98.78C80.0986 93.8813 76.1274 89.91 71.2286 89.91C66.3299 89.91 62.3586 93.8813 62.3586 98.78C62.3586 103.679 66.3299 107.65 71.2286 107.65Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1185 104.09L16.1885 106.49C15.5488 106.546 14.9042 106.476 14.2918 106.282C13.6794 106.089 13.1112 105.777 12.6198 105.363C12.1283 104.95 11.7233 104.443 11.4279 103.873C11.1326 103.303 10.9527 102.68 10.8985 102.04L3.01854 11.92C2.96241 11.2779 3.03404 10.6311 3.22927 10.0168C3.4245 9.40257 3.73948 8.83309 4.15601 8.34125C4.57254 7.84941 5.08238 7.44495 5.65608 7.15123C6.22978 6.8575 6.85599 6.68034 7.49854 6.62996L65.2985 1.57996",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5286 31.37L50.9686 30.45",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2886 40.08L49.5286 39.36",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0386 48.7L47.4686 48.22",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6785 67.46L48.0385 67.08",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.999 50.02L119.279 48.38L120.919 29.66",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9985 56.24L121.249 58.89",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2285 64.95L120.479 67.5999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4785 73.5699L113.599 75.6799",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8386 92.33L118.089 94.98",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0786 101.05L117.329 103.69",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3186 109.66L110.449 111.77",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H140V135H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagesStampsGrey);
export default __webpack_public_path__ + "static/media/pages_stamps_grey.561ad519438b0b01758dfd81db4885f6.svg";
export { ForwardRef as ReactComponent };